<div #overlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin (click)="clickToOpen ? onClick(): ''">
  <ng-content />
</div>

@if(isOpened) {
  <sd-core-modal
    #coreModal
    [brand]="brand"
    [overlayOrigin]="overlayOrigin"
    [modalType]="_type"
    [focus]="focus"
    [modalCustomClass]="modalCustomClass"
    [modalCustomId]="modalCustomId"
    [modalPosition]="position"
    [modalBackDrop]="backdrop"
    [modalClickToClose]="clickToClose"
    [disabledAnimation]="disabledAnimation"
    [(isOpened)]="isOpened"
    (isOpenedChange)="isOpenedChange.emit($event)"
  >
    <ng-content sd-modal-close select="[sd-modal-close]" />
    <ng-container *ngTemplateOutlet="modalContent" />
  </sd-core-modal>
} @else {
  <div class="is-hidden" data-testid="hidden">
    <ng-container *ngTemplateOutlet="modalContent" />
  </div>
}

<ng-template #modalContent>
  <ng-content select="[sd-modal-header]" />
  <ng-content select="[sd-modal-body]" />
</ng-template>
